import ShowTaxDeductionCertDataPageContainer from './containers/ShowTaxDeductionCertDataPageContainer';

export default ShowTaxDeductionCertDataPageContainer;
